import axios from "axios";
import { serverAddress } from "../../constant";
import cookie from 'js-cookie';

const UserAPI = {

    loginUser:async(params,signedIn)=>{
        // const url = `${serverAddress}/api/user/login`;
        const url = `${serverAddress}/user/login?signedIn=${signedIn}`;
       
        return await fetch(url, {
            method: "POST",
            headers:{
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${cookie.get('ajwt')}`
            },
            body: params,
          });

    },
    verifyLoginOTP: async (params, signedIn) => {
        const url = `${serverAddress}/user/verify-login-otp?signedIn=${signedIn}`;
        return await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
            body: JSON.stringify(params),
        });
    },
    resendLoginOTP: async (params) => {
        const url = `${serverAddress}/user/resend-login-otp`;
        return await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
            body: JSON.stringify(params),
        });
    },
    verifyToken:async()=>{
        let url=serverAddress+`/user/check-login?token=${cookie.get('ajwt')}`;
        return await fetch (url,{
            headers:{
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${cookie.get('ajwt')}`
            },
        })
    },
    searchQuery: (params,page,limit)=>{
        // let url=serverAddress+`/api/user/search?page=${page}&limit=${limit}`;
        let url=serverAddress+`/user/search?page=${page}&limit=${limit}`;
        return axios.post(url,params,{
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${cookie.get("ajwt")}`,
          },
        })
      },

    verifyEmail: (params) => {
        // let url = serverAddress + `/api/user/verify-email`;
        let url = serverAddress + `/user/verify-email`
        return axios.post(url, params,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${cookie.get('ajwt')}`
                },
            }
        );
    },

    verifyOTP: (params) => {
        // let url = serverAddress + `/api/user/verify-otp`;
        let url = serverAddress + `/user/verify-otp`;
        return axios.post(url, params,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${cookie.get('ajwt')}`
                },
            }
        );
    },

    UpdatePassword: (params) => {
        // let url = serverAddress + `/api/user/update-password`;
        let url = serverAddress + `/user/update-password`;
        let data = {
            username: params?.username,
            password: params?.password,
        }
        return axios.patch(url, data,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${cookie.get('ajwt')}`
                },
            }
        );
    },


    // get all users 
    getAllUsers: (params) => {
        // let url = serverAddress + `/api/user/get-all?page=${params?.page}&limit=${params?.limit}`;
        let url = serverAddress + `/user/get-all?page=${params?.page}&limit=${params?.limit}`;
        return axios.get(url,
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${cookie.get('ajwt')}`
                },
            }
        );
    },
 // createUser

 createUser:(params)=>{
    // let url = serverAddress + `/api/user/create`
    let url = serverAddress + `/user/create`

    return axios.post(url,params, 
        {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${cookie.get('ajwt')}`
            },
        }
        
        )
 },

 /* UPDATE PASSWORD NEW */

 updatePasswordNew:async (params,signedIn)=>{
    let response;
        // let url= `${serverAddress}/api/user/update-password`;
        let url= `${serverAddress}/user/update-password?signedIn=${signedIn}`;
        return  await fetch(url, {
            method: "PATCH",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${cookie.get('ajwt')}`
            },
            body: params,
          });
        
 },


 logout: async () => {
    const url = `${serverAddress}/user/logout`;
    return await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: `Bearer ${cookie.get('ajwt')}`
      },
    });
 },

 releaseUserSession: (userId) => {
    const url = `${serverAddress}/user/force-signout`;
    return axios.post(url, { _id: userId }, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
 },

 //deleteUser

 deleteUser:async(params)=>{
    // let url= `${serverAddress}/api/user/delete`;
    let url= `${serverAddress}/user/delete`;
        return await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${cookie.get('ajwt')}`
            },
            body: params,
          });
 },

 /*Get Profile Details*/

 getProfileDetails:async (params)=>{
    return await fetch(
        `${serverAddress}/user/get/${cookie.get("user")}`
      );

 },


 /*Update Profile details*/

 updateProfileDetails:async(params)=>{
    let url=`${serverAddress}/user/updateDetails`;
    return await fetch(url,{
        method: "PATCH",
        body: params,
        
    })
 },

 // Update Role
updateRole:async(params)=>{
    let url=`${serverAddress}/user/update-role`;
    return await fetch(url,{
        method: "PATCH",
        body: params,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${cookie.get('ajwt')}`
        },
    })
 },




 // Create 



 createRole:(params)=>{
    let url = serverAddress + `/role/create`
    return axios.post(url, params, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${cookie.get("ajwt")}`,
        },
      });
},

getallRoles: (params) => {
    // let url = serverAddress + `/api/enquiry/get/total/enquiry`;
    let url = serverAddress + `/role/get-all`;
    return axios.get(url,
        {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: `Bearer ${cookie.get('ajwt')}`
            },
        }
    );
},

getSessionLogs: (params = {}) => {
    const q = new URLSearchParams();
    if (params.page) q.set('page', params.page);
    if (params.limit) q.set('limit', params.limit);
    if (params.username) q.set('username', params.username);
    if (params.event_type) q.set('event_type', params.event_type);
    if (params.status) q.set('status', params.status);
    if (params.from) q.set('from', params.from);
    if (params.to) q.set('to', params.to);
    const url = `${serverAddress}/session-logs/get-all?${q.toString()}`;
    return axios.get(url, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${cookie.get('ajwt')}`,
        },
    });
},

getActiveSessions: () => {
    const url = `${serverAddress}/session-logs/active`;
    return axios.get(url, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${cookie.get('ajwt')}`,
        },
    });
},

getLockedAccounts: () => {
    const url = `${serverAddress}/user/locked-accounts`;
    return axios.get(url, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${cookie.get('ajwt')}`,
        },
    });
},

unlockAccount: (userId) => {
    const url = `${serverAddress}/user/unlock-account`;
    return axios.post(url, { _id: userId }, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: `Bearer ${cookie.get('ajwt')}`,
        },
    });
},

exportSessionLogs: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== '') q.set(k, v);
    });
    const url = `${serverAddress}/session-logs/export?${q.toString()}`;
    return fetch(url, {
        headers: {
            Authorization: `Bearer ${cookie.get('ajwt')}`,
        },
    });
},





};







/* Forget Password */
export default UserAPI;
